@if (record) {
  <div class="modal fade" id="edit-record-modal" tabindex="-1">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit record</h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="form-group col-md-6">
              <label>Title</label>
              <input type="text" class="form-control" name="title" [(ngModel)]="record.title" placeholder="Title" maxlength="140">
            </div>
            <div class="form-group col-md-3">
              <label>Activity</label>
              <select class="form-control" name="activity" [(ngModel)]="record.activity" required>
                <option value="" disabled>Select activity type</option>
                @for (a of activities; track a) {
                  <option [value]="a">{{a}}</option>
                }
              </select>
            </div>
            <div class="form-group col-md-3">
              <label>Status</label>
              <select class="form-control" name="status" [(ngModel)]="record.status" required>
                <option value="" disabled>Select status</option>
                @for (s of statuses; track s) {
                  <option [value]="s">{{s}}</option>
                }
              </select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-3">
              <label>Due date</label>
              <input type="date" class="form-control" name="date" [(ngModel)]="record.date" [pattern]="dateRegexp" placeholder="YYYY-MM-DD">
            </div>
            <div class="form-group col-md-3">
              <label>Meeting feedback</label>
              <select class="form-control" name="feedback" [(ngModel)]="record.feedback">
                <option value="">Select meeting feedback</option>
                @for (f of feedbacks; track f) {
                  <option [value]="f">{{f}}</option>
                }
              </select>
            </div>
            <div class="form-group col-md-3">
              <label>Follow up required</label>
              <select class="form-control" name="followup" [(ngModel)]="record.followup">
                <option value="">Select follow up</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>
            <div class="form-group col-md-3" [ngClass]="{ 'disabled': record.followup !== 'yes' }">
              <label>Follow up notes @if (record.followup === 'yes') {
                <span class="text-danger small">(required)</span>
              }</label>
              <textarea class="form-control" rows="2" name="followupnotes" [(ngModel)]="record.followupnotes" placeholder="Follow up notes"></textarea>
            </div>
          </div>
          @if (record.activity === 'UTOPIA Studios - URANIA') {
            <div class="row">
              <div class="form-group col-md-4">
                <label>Format <span class="text-danger small">(required)</span></label>
                <select class="form-control" name="format" [(ngModel)]="record.format">
                  <option value="">Select format</option>
                  @for (f of formats; track f) {
                    <option [value]="f">{{f}}</option>
                  }
                </select>
              </div>
              <div class="form-group col-md-4">
                <label>Moderator <span class="text-danger small">(required)</span></label>
                <input type="text" class="form-control" name="moderator" [(ngModel)]="record.moderator" placeholder="Moderator name">
              </div>
            </div>
          }
          <div class="row">
            <div class="form-group col-md-6">
              <label>
                Notes <span class="text-danger small">(required)</span>
                <a class="ms-2 small" [routerLink]="" (click)="addListItem('todo')" tabindex="-1"><i class="fa fa-square-o"></i> Add todo</a>
                <a class="ms-2 small" [routerLink]="" (click)="addListItem('done')" tabindex="-1"><i class="fa fa-check-square-o"></i> Add done</a>
                <a class="ms-2 small" [routerLink]="" (click)="addListItem('hours')" tabindex="-1"><i class="fa fa-clock-o"></i> Add hours</a>
              </label>
              <textarea class="form-control" rows="5" name="notes" [(ngModel)]="record.notes" placeholder="Activity description" required></textarea>
            </div>
            <div class="form-group col-md-6">
              <label>Client's participants</label>
              <textarea class="form-control" rows="5" name="clients" [(ngModel)]="record.clients" placeholder="Client's participant names and roles"></textarea>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-4">
              <label>Google Drive URL</label>
              <input type="url" class="form-control" name="driveurl" [(ngModel)]="record.driveurl" [pattern]="urlRegexp" placeholder="https://drive.google.com/abc123">
            </div>
            <div class="form-group col-md-4">
              <label>External URL 1</label>
              <input type="url" class="form-control" name="externalurl" [(ngModel)]="record.externalurl" [pattern]="urlRegexp" placeholder="https://example.com">
            </div>
            <div class="form-group col-md-4">
              <label>External URL 2</label>
              <input type="url" class="form-control" name="externalurl2" [(ngModel)]="record.externalurl2" [pattern]="urlRegexp" placeholder="https://example.com">
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
            [disabled]="isModalInvalid()"
            (click)="updateRecord(record)">
            <i class="fa fa-floppy-o"></i> Save
          </button>
        </div>
      </div>
    </div>
  </div>
}
